import React, { PropTypes } from 'react';
import { FormattedHTMLMessage, FormattedMessage, injectIntl, intlShape } from 'react-intl';
import ShelfActions from '../../../actions/ShelfActions';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { AlertSuccess, AlertDismiss } from '@bibliocommons/base-alerts';

const ShelfMessageTypes = {
  ADD: 'ADD',
  REMOVE: 'REMOVE',
  MOVE: 'MOVE',
  PRIVACY: 'PRIVACY'
};

export class ShelfMessage extends BcReactComponent {
  constructor(props) {
    super(props);
    this.timeout = null;

    this.bindAll('clearMessage', 'handlePrivacyChange');
  }

  componentDidMount() {
    this.scheduleMessageClearance();
  }

  componentWillReceiveProps(nextProps) {
    if (this.timeout && nextProps.message !== this.props.message) {
      clearTimeout(this.timeout);
      this.timeout = null;
      this.scheduleMessageClearance();
    }
  }

  scheduleMessageClearance() {
    const { clearMessages, duration } = this.props;
    if (duration) {
      this.timeout = setTimeout(() => {
        clearMessages();
        this.timeout = null;
      }, duration);
    }
  }

  clearMessage() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.props.clearMessages();
  }

  handlePrivacyChange(e) {
    e.preventDefault();

    this.clearMessage();

    const shelfItem = this.props.values;
    this.props.dispatch(
      ShelfActions.updateShelfItems({
        shelfName: shelfItem.get('shelf'),
        shelfItemIds: [shelfItem.get('id')],
        metadataIds: [shelfItem.get('metadataId')],
        newShelfName: shelfItem.get('shelf'),
        privateItem: !shelfItem.get('privateItem')
      })
    );
  }

  getListName() {
    return this.props.intl.formatMessage({
      id: `section_title_users_${this.props.values.get('shelf')}_library`
    });
  }

  getShelfMessage() {
    const id = this.props.message.get('id');
    const values = this.props.message.get('values');
    switch (id) {
      case ShelfMessageTypes.ADD:
        if (values.privateItem) {
          return `message_add_to_${values.get('shelf')}_library`;
        }
        return `message_shared_on_${values.get('shelf')}_library`;
      case ShelfMessageTypes.REMOVE:
        return 'message_remove_from_list';
      case ShelfMessageTypes.MOVE:
        return 'message_update_item_status';
      case ShelfMessageTypes.PRIVACY:
        if (values.get('privateItem')) {
          return 'content_marked_private';
        }
        return `content_marked_public_${values.get('shelf')}`;
      default:
        return null;
    }
  }

  renderPrivacyMessage() {
    if (this.props.message.get('id') === ShelfMessageTypes.ADD || this.props.message.get('id') === ShelfMessageTypes.PRIVACY) {
      const message = this.props.message.get('id') === ShelfMessageTypes.ADD
        ? (<FormattedHTMLMessage
          id={this.props.values.get('privateItem') ? 'make_public' : 'make_private'} />)
        : <FormattedMessage id="undo" />;
      return (
        <div>
          <a role="button" href="#handlePrivacyToggle" onClick={this.handlePrivacyChange}>
            {message}
          </a>
        </div>
      );
    }
    return null;
  }

  render() {
    return (
      <AlertSuccess>
        <AlertDismiss handleDismiss={this.clearMessage} />
        <FormattedHTMLMessage
          id={this.getShelfMessage()}
          values={{
            ...this.props.values.toObject(),
            list_name: this.getListName(),
            titles: this.props.values.get('title')
          }} />
        {this.renderPrivacyMessage()}
      </AlertSuccess>
    );
  }
}

ShelfMessage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  message: PropTypes.shape({
    id: PropTypes.string
  }).isRequired,
  duration: PropTypes.number,
  clearMessages: PropTypes.func.isRequired,
  fieldErrors: PropTypes.objectOf(PropTypes.shape({
    classification: PropTypes.string,
    message: PropTypes.string
  })),
  intl: intlShape
};

ShelfMessage.defaultProps = {
  duration: 20000
};

export default injectIntl(ShelfMessage);



// WEBPACK FOOTER //
// ./app/components/shared/Messages/ShelfMessage.jsx